import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaCaretLeft } from "react-icons/fa";
import useUser from "../../hook/useUser.js"
import Header from "../Header.js";
import api from "../../api/axios.js";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const Result = () => {
    const navigate = useNavigate();
    // const location = useLocation();

    const { id, employeeId } = useParams();
    const { user } = useUser();

    const [resultData, setResultData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showMessage, setShowMessage] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    useEffect(() => {
        api
          .get(`/api/quiz-result/${id}/${employeeId}`)
          .then((res) => {
            setResultData(res.data);
          })
          .catch((err) => {
            console.log(err)
          })
          .finally(() =>{
            setLoading(false);
          });
    }, [id, employeeId]);

    if(loading) return <p>Loading...</p>;

    if(!resultData) return <p>Result not found</p>;

    const correctNumLen = resultData?.correctNum || 0;
    const maxQuizLen = resultData?.totalNum || 0;
    const score = resultData?.score || 0;
    const result = resultData.result || "";
    const timeSpent = resultData?.timeSpent || "00:00:00";
    const quizTitle = resultData.quizTitle || "";

    let message;
    if(score === 100){
        message = "Perfect score";
    } else if(score >= 70){
        message = "Good score";
    }else {
        message = "Fail";
    }

    let resultMessage;
    if(score >= 70){
        resultMessage = "Congratulation ";
    }else {
        resultMessage = "Please try harder";
    }

    console.log(resultData)

    return (
        <div className="dashboard-wrapper">
           <div className="result_title">
                    <Header />
                </div>
            <h2>Result</h2>
            
            <div className="result_card">
                <div className="resultChart"
                     style={{
                        backgroundColor: score >= 70 ? "#98AC64" : "#C50404",
                        color: score >= 70 ? "#2E2E2E" : "#FFFDF6"
                     }}>
                    <div className="resultCircle">
                        <h1>{score}%</h1>
                        <p>{message}</p>
                    </div>
                </div>
                <div className="resultDashboard">
                    <p>{resultMessage}, {user ? user.employeeName : "Loading..."}!
                    </p>
                </div>
                <div className="result_info_cards">
                    <div className="result_info_card">
                        <p className="result_info_label">Correct Answers</p>
                        <h3>{correctNumLen}/{maxQuizLen}</h3>
                    </div>
                    <div className="result_info_card">
                        <p className="result_info_label">Time Spent</p>
                        <h3 className="result_info_value">{timeSpent}</h3>
                    </div>

                    <div className="result_info_card result_info_card_result">
                        <p className="result_info_value">{result}</p>
                    </div>
                </div>

              <div className="btn-wrapper employee_feedback_view-btn_wrapper">
                    <button type="submit" className="employee_feedback_return_btn" onClick={() => navigate("/quiz/main")}>Your Quiz</button>
                    <button type="submit" className="employee_feedback_next_btn" onClick={() => navigate("/dashboard/general-training")}>Next Module</button>
                </div>
                
            </div>
        </div>
    );
}

export default Result;